/* ==========================================================================
   My Petsworth — Bundle discount, live cart logic
   Buy 2 = 10% off  ·  Buy 3+ = 15% off
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------
     CONFIG — het enige dat je ooit hoeft aan te passen
     --------------------------------------------------------------- */

  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 }
  ];

  // 'units' = telt stuks (2x hetzelfde product telt ook mee)
  // 'lines' = telt verschillende producten
  var COUNT_MODE = 'units';

  // Toon het geschatte bedrag. Zet op false als je thema de korting
  // al onder het subtotaal laat zien.
  var SHOW_AMOUNT = true;

  /* ---------------------------------------------------------------
     Intern
     --------------------------------------------------------------- */

  var refreshTimer = null;

  function modules() {
    return document.querySelectorAll('[data-mpw-bundle]');
  }

  function money(cents) {
    return '\u00A3' + (cents / 100).toFixed(2);
  }

  function countFor(cart) {
    if (COUNT_MODE === 'lines') return cart.items ? cart.items.length : 0;
    return cart.item_count || 0;
  }

  function evaluate(count) {
    var current = null;
    var next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].qty) current = TIERS[i];
    }
    for (var j = 0; j < TIERS.length; j++) {
      if (count < TIERS[j].qty) { next = TIERS[j]; break; }
    }
    return { current: current, next: next };
  }

  function buildMessage(count, subtotal) {
    var state = evaluate(count);
    var tick = '<span class="mpw-cp__tick" aria-hidden="true">\u2713</span>';

    if (count === 0) {
      return 'Add ' + TIERS[0].qty + ' items and save <b>' + TIERS[0].pct + '%</b>';
    }

    if (!state.next) {
      var extra = '';
      if (SHOW_AMOUNT && subtotal) {
        extra = ' (about ' + money(Math.round(subtotal * (state.current.pct / 100))) + ')';
      }
      return tick + '<b>' + state.current.pct + '% off</b> \u2014 your biggest saving' + extra;
    }

    var needed = state.next.qty - count;

    if (state.current) {
      return tick + '<b>' + state.current.pct + '% off</b> \u2014 add ' + needed +
             ' more for <b>' + state.next.pct + '%</b>';
    }

    return 'Add ' + needed + ' more ' + (needed === 1 ? 'item' : 'items') +
           ' and save <b>' + state.next.pct + '%</b>';
  }

  function paint(count, subtotal) {
    var list = modules();
    if (!list.length) return;

    // Stapsgewijs: 0 = 0%, tier 1 = 50%, tier 2 = 100%
    var fill;
    if (count >= TIERS[1].qty)      fill = 100;
    else if (count >= TIERS[0].qty) fill = 50;
    else                            fill = count * 25;

    for (var i = 0; i < list.length; i++) {
      var el = list[i];

      var msg = el.querySelector('[data-mpw-message]');
      if (msg) msg.innerHTML = buildMessage(count, subtotal);

      var bar = el.querySelector('[data-mpw-fill]');
      if (bar) bar.style.width = fill + '%';

      var steps = el.querySelectorAll('[data-mpw-step]');
      for (var s = 0; s < steps.length; s++) {
        var stepNeed = parseInt(steps[s].getAttribute('data-mpw-step'), 10);
        steps[s].classList.toggle('is-on', count >= stepNeed);
      }

      el.removeAttribute('hidden');
    }
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(countFor(cart), cart.total_price); })
      .catch(function () { /* server-rendered stand laten staan */ });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 120);
  }

  function isCartUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart') !== -1;
  }

  /* ---------------------------------------------------------------
     Watchers — vangt elke manier waarop de cart kan wijzigen
     --------------------------------------------------------------- */

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (isCartUrl(url)) scheduleRefresh();
        return response;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (isCartUrl(url)) scheduleRefresh();
    });
    return nativeOpen.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build',
   'ajaxCart.afterCartLoad', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, scheduleRefresh);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();